import { IPersonalityReport } from 'affiny-core/modules/personalityReport/types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

enum EReportTypes {
  value = 'value',
  vision = 'vision',
  personality = 'personality',
}

interface IApiPersonalityReport {
  data: IPersonalityReport;
}

const getReport = async (type: EReportTypes, accountId: string) => {
  const response = await AffinyEndpoint.PersonalityReport.url(
    `/${accountId}/${type}`
  )
    .get()
    .json<IApiPersonalityReport>();

  return response.data;
};

export const PersonalityReportResource = {
  getValues: async (accountId: string) =>
    getReport(EReportTypes.value, accountId),
  getVision: async (accountId: string) =>
    getReport(EReportTypes.vision, accountId),
  getPersonality: async (accountId: string) =>
    getReport(EReportTypes.personality, accountId),
};
